import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { CreateLibraryForm } from 'features/classCreation';
import SectionHeading from 'components/SectionHeading';
import styles from './CreateLibraryPage.module.scss';

export default function CreateLibraryPage() {
  const navigate = useNavigate();

  const handleSuccess = useCallback(
    (library) => {
      navigate(`/classes/edit-library/${library.id}`);
    },
    [navigate]
  );

  return (
    <div>
      <SectionHeading
        title="CREATE LIBRARY"
        subtitle="Fill in the following details to create a new library."
      />
      <CreateLibraryForm
        className={styles.pageContainer}
        onSuccess={handleSuccess}
      />
    </div>
  );
}
